import { SxProps }                      from '@mui/system';
import { Theme }                        from '@mui/material/styles';
import { Grid, TypographyTypeMap }      from '@mui/material';
import { FormFields, IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { SectionTitle }                 from '@shared/components/SectionTitle';

interface FormPartProps<T> {
  config: IFormFieldConfig<T>[];
  useFastFields?: boolean;
  name?: string;
  sx?: SxProps<Theme>;
  marginTop?: number;
  marginBottom?: number;
  variant?: TypographyTypeMap['props']['variant']
}

export const FormPart = <T,>({
  config,
  name,
  sx,
  marginTop,
  marginBottom,
  variant,
  useFastFields = false,
}: FormPartProps<T>) => (
  <>
    {name && (
      <SectionTitle
        title={name} 
        marginTop={marginTop}
        marginBottom={marginBottom}
        variant={variant}
      />
    )}

    <Grid container rowSpacing={3} columnSpacing={3} sx={sx || { mb: 6 }}>
      <FormFields 
        useFastFields={useFastFields}
        config={config} 
      />
    </Grid>
  </>
);
